'use client';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, LogOut } from 'lucide-react';
import { useWorkspaceStore } from '@/hooks/state';
import { signOut } from '@/services/auth/authService';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from './dropdown-menu';
import { cn } from '../../utils';
import { UnifiedAvatar } from './unified-avatar';
import { ThemeMenuSub } from './theme-menu';
import { useWorkspaceSwitcher } from '@/hooks/useWorkspaceSwitcher';

export const HeaderUserProfile: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { userInfo } = useWorkspaceStore();
  const { currentUserId } = useWorkspaceSwitcher();

  const handleSignOut = () => {
    signOut();
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <button className={cn(
          'flex items-center gap-1.5 h-8 px-2 rounded-lg',
          'bg-transparent hover:bg-surface-hover',
          'transition-colors duration-200',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1',
          'flex-shrink-0',
          isOpen && 'bg-muted',
        )}>
          {/* User avatar */}
          <UnifiedAvatar
            profileImageUrl={userInfo?.profile_image_url}
            avatarId={userInfo?.avatar_id}
            firstName={userInfo?.firstName}
            lastName={userInfo?.lastName}
            email={userInfo?.email}
            userId={currentUserId}
            size="xs"
            className="flex-shrink-0 ring-1 ring-primary/20"
          />

          {/* Chevron icon */}
          <ChevronDown className="w-3.5 h-3.5 text-ink-supporting flex-shrink-0 transition-transform duration-200" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        alignOffset={-4}
        side="bottom"
        sideOffset={8}
        className="w-64 z-overlay p-1"
        collisionPadding={{ right: 16 }}
      >
        {/* My Profile */}
        {/* The item NAVIGATES, so it renders as a real `<a>` (`asChild` +
            `<Link>`): ⌘/Ctrl-click, middle-click and "Open in new tab" work,
            and a plain click still routes client-side. */}
        <DropdownMenuItem asChild className="cursor-pointer px-2 py-1.5 h-8">
          <Link to="/settings/profile" className="no-underline text-inherit">
            <span className="text-sm">My Profile</span>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuSeparator className="my-1" />

        {/* Appearance — THE shared theme submenu (also mounted by apps/internal). */}
        <ThemeMenuSub />

        <DropdownMenuSeparator className="my-1" />

        {/* Sign Out */}
        <DropdownMenuItem
          onClick={handleSignOut}
          className="gap-2 cursor-pointer px-2 py-1.5 h-8 text-ink-supporting focus-visible:text-ink-supporting"
        >
          <LogOut className="w-4 h-4 flex-shrink-0" />
          <span className="text-sm">Sign out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};